/**
 * main.tsx - FMwvTool v4 entry point
 * 
 * CHANGE HISTORY:
 * - 251031_2150 [pending] danielbeer: Initial creation
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/main.css';
import './styles/tools.css';
import './styles/instructions.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
